import Stats from 'stats.js'

const stats = new Stats()
stats.showPanel(0)
const isDevelopment = process.env.NODE_ENV !== 'production'

export const initStats = isDevelopment ? () => document.body.appendChild(stats.dom) : () => {}
export const statStart = isDevelopment ? () => stats.begin() : () => {}
export const statsEnd = isDevelopment ? () => stats.end() : () => {}
